import React from "react";

import { Alert } from "clearsense-ui/components";

const ResetAlert = ({ isOpen, close }) => (
  <Alert
    isOpen={isOpen}
    onClose={close}
    submitButtonLabel="Reset"
    cancelButtonLabel="No Need!"
    title="Reset your data"
    message="You have changed which column is used to detect new records for a stream. You may want to reset the data in your stream."
  />
);

export default ResetAlert;
